module.exports = __webpack_public_path__ + "img/lingua_espanhola.65cf29e4.svg";